var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShareFilled = function SvgShareFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m23.12 10.12-5.4 5.58a1.015 1.015 0 0 1-1.42.02.987.987 0 0 1-.02-1.41l5.14-5.3H13c-1.65 0-3 1.35-3 3v5c0 .55-.45 1-1 1s-1-.45-1-1v-5c0-2.76 2.24-5 5-5h8.42L16.28 1.7A.996.996 0 0 1 16.3.29a.996.996 0 0 1 1.41.02l5.41 5.59a2.997 2.997 0 0 1-.01 4.23zm-8.21 7.03c-.37-.36-1.87-2.35-2.91-3.75v3.48c0 1.48-.98 2.78-2.4 3.06C7.68 20.31 6 18.85 6 17v-5c0-1.96.81-3.73 2.11-5H5c-2.76 0-5 2.24-5 5v7c0 2.76 2.24 5 5 5h7c2.76 0 5-2.24 5-5v-1c-.78 0-1.53-.3-2.09-.85"
  })));
};
export default SvgShareFilled;